import React from 'react';
import type { ImageSourcePropType } from 'react-native';
import { Box, IBoxProps } from '@styleseat/ui';
import Image from '../../shared/Image';

type ImageBoxProps = IBoxProps & {
  width: number | string;
  height: number | string;
  resizeMode?: 'cover' | 'contain' | 'stretch' | 'repeat' | 'center';
  source?: ImageSourcePropType;
  sourceURL?: string;
  accessibilityLabel: string;
};

/**
 * Renders an image with the specified dimensions or a Box that will take up the same
 * amount of space.
 * @param width
 * @param height
 * @param source source object to pass into Image (optional)
 * @param sourceURL shortcut to passing in a source object with just an url prop
 * @param restProps
 * @constructor
 */
export const ImageBox = ({
  width,
  height,
  source,
  sourceURL,
  resizeMode = 'cover',
  ...restProps
}: ImageBoxProps) => (
  <Box {...restProps} maxWidth={width} maxHeight={height}>
    {source || sourceURL ? (
      <Image
        resizeMode={resizeMode}
        source={source || { uri: sourceURL }}
        style={{
          width,
          height,
          resizeMode,
        }}
      />
    ) : (
      <Box minHeight={height} minWidth={width} />
    )}
  </Box>
);

export default ImageBox;
